/**
 * sportlink
 * Per academieteam willen we het programma, stand en uitslagen weergeven. We kunnen de data hiervan halen uit een API van Sportlink.
 * https://service.thevalley.nl/browse/UTR-199
 *
 */
const sportlink = () => {
	const $tables = document.querySelectorAll('.js-sportlink');

	$tables.forEach((el) => {
		const uri = el.dataset.sportlinkUri,
			  type = el.dataset.sportlinkType;
			  
		var request = new XMLHttpRequest();

		request.open('GET', uri, true);
		request.onload = function() {
			if (this.status >= 200 && this.status < 400) {
				var data = JSON.parse(this.response);
				if (type == 'uitslagen') {
					showDataU(data, el)
				} else if (type == 'programma') {
					showDataP(data, el);
				}
			} else {
				console.error('Sportlink API seems to have generated an error.');
			}
		};
		request.onerror = function() {
			console.error('Sportlink API seems to have generated an error.');
		};

		request.send();
	});


	function showDataP(jsonObj, table) {
		const programma = jsonObj;
		const tableBody = document.createElement('TBODY');

		
		for (let i = 0; i < programma.length; i++) {
			if (Number(table.dataset.sportlinkId) === programma[i].thuisteamid || Number(table.dataset.sportlinkId) === programma[i].uitteamid) {
				const datum = document.createElement('td');
				datum.textContent = programma[i].kaledatum;
				var date = new Date(programma[i].kaledatum)	;
				var dateNew = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
				datum.innerHTML = dateNew;
				const tijd = document.createElement('td');
				tijd.textContent = programma[i].aanvangstijd;
				const thuisteam = document.createElement('td');
				thuisteam.textContent = programma[i].thuisteam;
				const uitteam = document.createElement('td');
				uitteam.textContent = programma[i].uitteam;
				const row = document.createElement('tr');
				row.appendChild(datum);
				row.appendChild(tijd);
				row.appendChild(thuisteam);
				row.appendChild(uitteam);
				tableBody.appendChild(row);
				table.appendChild(tableBody);
			};
		}
	}

	function showDataU(jsonObj, table) {
		const uitslagen = jsonObj;
		const tableBody = document.createElement('TBODY');
		
		for (let i = 0; i < uitslagen.length; i++) {
			if (table.dataset.sportlinkId === uitslagen[i].thuisteamid || table.dataset.sportlinkId === uitslagen[i].uitteamid) {
				const datum = document.createElement('td');
				datum.textContent = uitslagen[i].datum;
				var date = new Date(uitslagen[i].datum)	;
				var dateNew = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
				datum.innerHTML = dateNew;
				const thuisteam = document.createElement('td');
				thuisteam.textContent = uitslagen[i].thuisteam;
				const uitteam = document.createElement('td');
				uitteam.textContent = uitslagen[i].uitteam;
				const uitslag = document.createElement('td');
				uitslag.textContent = uitslagen[i].uitslag;
				const row = document.createElement('tr');

				row.appendChild(datum);
				row.appendChild(thuisteam);
				row.appendChild(uitteam);
				row.appendChild(uitslag);
				tableBody.appendChild(row);
				table.appendChild(tableBody);
			};
		}
	}
};
module.exports = sportlink;
